import isEqual from 'lodash/isEqual';

import { GlsCheck } from '@evidentid/gls-service-api-client/types';
import Question from '@evidentid/ido-lib/interfaces/Question';

import UserData from '@/interfaces/UserData';
import type { GlsBasicCaseData } from '@/services/getGlsSessionInterview';
import { ValuesMap } from '@/store/interfaces/IdoState';

/**
 * Build automatic submission values,
 * when the case could proceed without any User's input.
 *
 * Otherwise, just return null,
 * so User may provide own values.
 */
export function buildImmediateGlsValues(
    caseData: GlsBasicCaseData,
    userData: UserData,
    questions: Question[],
): ValuesMap | null {
    const isFieldWorkerOnlyCase = isEqual(caseData.requiredChecks, [ GlsCheck.fieldWorkerCriminal ]);
    const isBusinessOwnerOnlyCase = isEqual(caseData.requiredChecks, [ GlsCheck.businessOwner ]);
    if (questions.length === 1 && (isFieldWorkerOnlyCase || isBusinessOwnerOnlyCase)) {
        return {
            [questions[0].attrType]: {
                list: [ userData.email ],
                confirmed: true,
            },
        };
    }

    return null;
}
